export default __webpack_public_path__ + "static/main_page_image_new-5c61045fb7221582ba0fd023562c8181.jpg";